'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var DocumentSign = function (_BaseIcon) {
  (0, _inherits3.default)(DocumentSign, _BaseIcon);

  function DocumentSign() {
    (0, _classCallCheck3.default)(this, DocumentSign);
    return (0, _possibleConstructorReturn3.default)(this, (DocumentSign.__proto__ || (0, _getPrototypeOf2.default)(DocumentSign)).apply(this, arguments));
  }

  (0, _createClass3.default)(DocumentSign, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M21.17 31.94H8.57C6.6 31.94 5 30.32 5 28.34V9.66c0-2 1.6-3.6 3.57-3.6h7.52c.9 0 1.9.4 2.6 1.1l5 5.47c.6.67.94 1.56.94 2.5v1.9c0 .57-.48 1.06-1.05 1.06-.57 0-1.06-.5-1.06-1.1v-1.9c0-.4-.15-.76-.4-1l-5.1-5.5c-.28-.3-.65-.46-1.05-.46H8.5c-.8 0-1.44.64-1.44 1.45v18.7c0 .8.68 1.47 1.48 1.47h12.6c.8 0 1.46-.67 1.46-1.48v-.27c0-.58.5-1.07 1.07-1.07.56 0 1.04.5 1.04 1.06v.26c0 2-1.6 3.6-3.52 3.6z'
        }, this.getPathProps())),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M11.17 22.76c.23-.18.54-.2.8-.03s.63.3 1.14.34c1.1.03 3-.57 5.9-3.78.27-.3.7-.4 1-.1.27.2.3.6.1.9-.55.94-1.1 2-1.4 2.7l.05-.05s0-.03.05-.03c1.14-.66 2.9-1.84 3.25-2.34.18-.2.5-.33.78-.25.48.15.65.67.4 1.04-.52.92-.95 2.1-.92 2.5.08 0 .16 0 .3-.08.8-.2 1.17-.47 1.5-.7.35-.26.75-.5 1.4-.44.5.06 1.07.35 2.04 1.02.02 0 .02 0 .02.02.1.1 1.04.73 2.16-.05.35-.2.8-.14 1 .2.2.33.1.76-.22 1-.65.45-1.3.6-1.9.6-.83 0-1.52-.3-1.9-.58-.3-.2-1.1-.72-1.42-.78-.05 0-.07 0-.4.2-.33.3-.9.7-1.93.92-1 .26-1.52-.1-1.74-.44-.27-.37-.36-.86-.2-1.53-.6.4-1.2.8-1.4.9-.5.37-1.5 1.06-2.16.4-.34-.3-.4-.73-.2-1.45-1.48 1.1-2.85 1.63-4.1 1.57-.8-.03-1.4-.32-1.8-.6-.44-.22-.44-.83-.07-1.1z'
        }, this.getPathProps()))
      );
    }
  }]);
  return DocumentSign;
}(_BaseIcon3.default);
/*eslint-enable */


DocumentSign.defaultProps = {
  width: 31,
  height: 36,
  viewBox: '0 0 31 36'
};
exports.default = DocumentSign;
//# sourceMappingURL=DocumentSign.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/DocumentSign.js
// module id = 292
// module chunks = 0